<template>
  <base-material-card color="primary" icon="mdi-broom" :title="title" inline class="ml-0 px-5 py-4">
    <v-form class="mt-5">
      <v-row align="center" class="mx-auto">
        <v-col cols="12">
          <validation-provider id="titulo-normas-tecnicas" v-slot="{ errors }" rules="required">
            <v-text-field v-model="nome" label="Título" outlined :error-messages="errors" />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row class="mx-auto">
        <v-col cols="12">
          <v-radio-group v-model="origem" mandatory :column="false" class="mt-0">
            <v-radio label="Preencher Manualmente" value="manual" class="mr-6" />
            <v-radio label="Arquivo .CSV" value="arquivo" />
          </v-radio-group>
        </v-col>
      </v-row>

      <v-row v-if="origem == 'arquivo'" align="center" class="mx-auto">
        <v-col id="normas-tecnicas-v-alert" cols="12" class="py-0">
          <v-alert dense outlined type="info" color="blue" class="pa-2">
            <a href="javascript:void(0)" @click="getArquivoPadrao()">Clique aqui</a>
            para exportar as Normas atuais do sistema. Edite as quantidades, salve como CSV e envie o arquivo.
            <br />
            O arquivo deve conter
            <b>apenas</b>
            as colunas:
            <b>Equipamento</b>
            ,
            <b>Componente Menor</b>
            ,
            <b>Tipologia</b>
            e
            <b>Quantidade</b>
            .
          </v-alert>
        </v-col>
      </v-row>

      <div v-if="origem == 'arquivo'" id="normas-tecnicas-campos-arquivo">
        <v-row align="center" class="mx-auto">
          <v-col cols="12" class="pl-2">
            <validation-provider v-slot="{ errors }" rules="required">
              <v-file-input
                v-model="arquivo.fileObj"
                label="Arquivo CSV"
                placeholder="Selecione um arquivo CSV"
                outlined
                accept=".csv, .zip"
                truncate-length="30"
                :loading="arquivo.uploading"
                loader-height="4"
                :success="arquivo.id && arquivo.fileObj ? true : false"
                :error-messages="errors"
                @change="uploadNewFile()"
              />
            </validation-provider>

            <validation-provider rules="required">
              <input type="hidden" name="validate-upload-normas-tecnicas" :value="arquivo.id" />
            </validation-provider>
          </v-col>
        </v-row>

        <parametros-arquivo-csv
          :delimitador.sync="arquivo.delimitador"
          :involucro.sync="arquivo.involucro"
          :escape.sync="arquivo.escape"
        />
      </div>

      <v-row v-if="origem == 'manual'" class="mx-auto">
        <v-col cols="12">
          <v-data-table
            :headers="[
              { text: 'Equipamento', value: 'equipamento' },
              { text: 'Compomente Menor', value: 'componente_menor' },
              { text: 'Tipologia', value: 'tipologia' },
              { text: 'Quantidade', value: 'quantidade', width: '80px' }
            ]"
            :items="normas"
            dense
            hide-default-footer
            disable-pagination
            disable-filtering
            disable-sort
            mobile-breakpoint="760"
          >
            <template v-slot:[`item.componente_menor`]="{ item }">
              {{ item.componente_menor | ChfusCom | PrCom }}
            </template>
            <template v-slot:[`item.quantidade`]="{ item }">
              <v-text-field
                v-model="item.quantidade"
                min="0"
                type="number"
                step="0.001"
                hide-details
                class="my-0 py-0"
                @blur="item.quantidade < 0 ? (item.quantidade = 0) : 1"
              />
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>
  import ArquivosService from '@/services/ArquivosService.js';
  import ConfiguracoesService from '@/services/ConfiguracoesService.js';
  import NormasTecnicasService from '@/services/parametrosComCa/NormasTecnicasService';
  import dayjs from 'dayjs';

  export default {
    name: 'ParametrosNormasTecnicas',

    components: {
      ParametrosArquivoCsv: () => import('@/components/general/GeneralParametrosArquivoCsv.vue')
    },

    filters: {
      ChfusCom(str) {
        return str.toUpperCase() == 'CHFUS' ? `${str}_COM` : str;
      },
      PrCom(str) {
        return str.toUpperCase() == 'PR' ? `${str}_COM` : str;
      }
    },

    data() {
      return {
        nome: '',
        origem: 'manual',
        normas: [],
        arquivo: {
          fileObj: undefined,
          id: '',
          delimitador: `;`,
          involucro: `"`,
          escape: `"`,
          uploading: false
        }
      };
    },

    computed: {
      user() {
        return this.$store.getters.getUser;
      },
      title() {
        return this.$route.params.id ? 'Editando Normas Técnicas' : 'Adicionando Normas Técnicas';
      }
    },

    mounted() {
      if (!this.$route.params.id) {
        this.getCsvCamposPadroes();
        this.getNormasPadroes();
      } else {
        this.getNorma(this.$route.params.id);
      }
    },

    methods: {
      getCsvCamposPadroes() {
        ConfiguracoesService.getCsvCamposPadroes()
          .then((response) => {
            this.arquivo.delimitador = response.data.campos.delimitador.valor;
            this.arquivo.involucro = response.data.campos.involucro.valor;
            this.arquivo.escape = response.data.campos.escape.valor;
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Erro ao recuperar campos padrões do arquivo csv.', '', { position: 'topRight' });
          });
      },
      getNormasPadroes() {
        NormasTecnicasService.getValoresPadroes()
          .then((res) => {
            this.normas = res.data.normasPadrao;
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar Normas Técnicas padrões do Sistema.', '', { position: 'topRight' });
          });
      },
      uploadNewFile() {
        if (!this.arquivo.fileObj) return;

        this.arquivo.id = '';
        this.arquivo.uploading = true;

        let data = new FormData();
        data.append('file', this.arquivo.fileObj);

        ArquivosService.uploadFile(data)
          .then((response) => {
            this.arquivo.id = response.data.arquivoId;
          })
          .catch((err) => {
            console.error('Erro ao fazer upload: ', err);

            if (err?.data?.error_code == 1001) {
              this.$toast.error(err.data.erro, '', { position: 'topRight', timeout: 6000 });
            } else if (err?.data?.cod_erro == 10000) {
              let msg = 'Há mais de um arquido dentro do ZIP.<br>Adicione apenas um arquivo CSV.';
              this.$toast.error(msg, '', { position: 'topRight', timeout: 8000 });
            } else {
              this.$toast.error('Erro no upload do arquivo.', '', { position: 'topRight' });
            }

            this.arquivo.fileObj = undefined;
          })
          .finally(() => (this.arquivo.uploading = false));
      },
      getNorma(id) {
        NormasTecnicasService.getNormasTecnicas(id)
          .then((res) => {
            this.nome = res.data.norma.nome;
            let jsonNormas = JSON.parse(res.data.norma.json);
            this.normas = [];

            Object.keys(jsonNormas).forEach((equipamento) => {
              for (const com in jsonNormas[equipamento]) {
                for (const tipologia in jsonNormas[equipamento][com]) {
                  this.normas.push({
                    id: this.normas.length + 1,
                    equipamento: equipamento,
                    componente_menor: com,
                    tipologia: tipologia,
                    quantidade: jsonNormas[equipamento][com][tipologia]
                  });
                }
              }
            });
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Erro ao recuperar Normas Técnicas.', '', { position: 'topRight' });
          });
      },
      getArquivoPadrao() {
        this.$toast.info('Processando...', '', { position: 'topRight', timeout: 1250 });

        NormasTecnicasService.getArquivoPadrao()
          .then(async (res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', `Normas Tecnicas ${dayjs().format('YYYYMMDDHHmmss')}.xlsx`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            this.$toast.error('Erro ao baixar arquivo padrão do sistema', '', { position: 'topRight' });
            console.error(err);
          });
      }
    }
  };
</script>

<style>

</style>